<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="listRosteringPlanList" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header"><i class="el-icon-user-solid el-icon--left"></i>在班人员</div>
          <div class="es-op-box">
            <el-input placeholder="请输入姓名" v-model="queryObj.keyWord" size="small" class="query"
              style="float: left;margin-bottom:10px" clearable
              @change="() => { this.queryObj.pageNum = 1; loadlistRosteringPlanList() }">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <el-table :data="pageData.list" ref="rosteringRuleTable" border stripe size="mini"
            height="calc(100vh - 250px)" v-loading="loading">
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="accountName" label="人员姓名">
            </el-table-column>
            <el-table-column prop="orgName" label="所属组织">
            </el-table-column>
            <el-table-column prop="rosteringName" label="排班类别名称">
            </el-table-column>
            <el-table-column prop="startTime" label="上班时间">
            </el-table-column>
            <el-table-column prop="endTime" label="下班时间">
            </el-table-column>
            <el-table-column prop="workHours" label="上班时长">
              <template slot-scope="scope">
                {{ (scope.row.workHours / 60).toFixed(1) }}
              </template>
            </el-table-column>
            <el-table-column prop="leaveHours" label="是否请假" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.leaveHours > 0" size="mini" type="warning">是</el-tag>
                <el-tag v-else size="mini" type="primary">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="overHours" label="是否加班" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.overHours > 0" size="mini" type="warning">是</el-tag>
                <el-tag v-else size="mini" type="primary">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-link :underline="false" title="查看" @click="edit_init(scope.row)" type="primary"><i
                    class="el-icon-font el-icon-view"></i></el-link>
                    <el-divider direction="vertical"></el-divider>
                <el-link :underline="false" title="查看日历" @click="displayCalendar(scope.row)"
                  type="primary"><i class="el-icon-menu
"></i></el-link>
              </template>
              
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
              @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadlistRosteringPlanList() }">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="editVisible" width="550px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>值班详情
      </span>
      <el-form :model="rosteringPlanInfo" size="mini" label-position="right" label-width="150px"
        ref="rosteringPlanForm">
        <el-form-item label="组织名称">
          <el-input v-model="rosteringPlanInfo.orgName" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="人员名称">
          <el-input v-model="rosteringPlanInfo.accountName" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="上班时间">
          <el-input v-model="rosteringPlanInfo.startTime" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="下班时间">
          <el-input v-model="rosteringPlanInfo.endTime" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="上班时长">
          <span>{{ ((rosteringPlanInfo.workHours + rosteringPlanInfo.overHours * 60 - rosteringPlanInfo.leaveHours * 60)
              / 60).toFixed(2)
          }}</span>
        </el-form-item>
        <el-form-item label="排班类型">
          <el-input style="width:250px" v-model="rosteringPlanInfo.rosteringName">
          </el-input>
        </el-form-item>
        <el-form-item label="加班时长">
          <el-input v-model="rosteringPlanInfo.overHours" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="加班开始时间">
          <el-input v-model="rosteringPlanInfo.overStartTime" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="加班结束时间">
          <el-input v-model="rosteringPlanInfo.overEndTime" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="请假时长">
          <el-input v-model="rosteringPlanInfo.leaveHours" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="请假开始时间">
          <el-input v-model="rosteringPlanInfo.leaveStartTime" style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item label="请假结束时间">
          <el-input v-model="rosteringPlanInfo.leaveEndTime" style="width:250px">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>
       <!--编辑区域-->
    <el-dialog :visible.sync="visible" :fullscreen="true" @closed="() => this.radio='2'">
      <span slot="title">
        <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>日历显示({{
              selectusername }})
      </span>
       <el-radio-group v-model="radio"  size="mini" @change="to_change">
     <el-radio-button label="1">地图显示</el-radio-button>
      <el-radio-button label="2">日历显示</el-radio-button>
  </el-radio-group>
            <el-row :gutter="15" :style="{ display: calVisible}" style="margin-top:10px; ">
      <el-col>
        <transition name="el-zoom-in-top">
          <el-card class="card">
            <div style="overflow:auto;height: calc(100vh - 179px);">
              <el-calendar v-model="currentdata">
                <template slot="dateCell" slot-scope="{date, data}">
                  <div>
                    <div>{{ data.day.split('-').slice(2).join('') }}</div>
                    
                   <el-row :gutter="8">
                    <el-col :span="6" v-for="item in personlist" :key="item.id" style="">
                      <div style="width: 257px;" v-if="item.startTime!=null&&data.day.substr(0, 10) == item.dutyTime.substr(0, 10)" @click="add_detail_tab(item)">
                        
                      <el-row style="margin-top: 5px">
                        <span>上班时间：{{item.startTime}}</span>
                      </el-row>
                       <el-row style="margin-top: 5px">
                        <span>下班时间：{{item.endTime}}</span>
                      </el-row>
                       
                      </div>
                      </el-col>
                    </el-row>
                  </div>
                </template>
              </el-calendar>

            </div>
          </el-card>
        </transition>
        <!--<el-button type="primary" class="map_button" icon="el-icon-map-location" @click="go_map">地图显示</el-button>
        <el-button type="success" class="back_button" icon="el-icon-back" @click="go_backmain">返回打卡</el-button>-->

        <el-drawer title="详情" :with-header="false" :visible.sync="singleposVisible" :append-to-body="true" direction="rtl" size="22%">
          <el-card class="drawtitle" shadow="always">
            <div class="demo-drawer__content">
              <br />
              <el-form :model="posinfo">
                <el-form-item label="打卡时间：" label-width="80px">
                  {{ posinfo.createTime }}
                </el-form-item>
                <el-form-item label="打卡经纬：" label-width="80px">
                  {{ posinfo.longitude }}， {{ posinfo.latitude }}
                </el-form-item>
                <el-form-item label="位置：" label-width="80px">
                  {{ posinfo.location }}
                </el-form-item>
                <el-form-item label="备注：" label-width="80px">
                  {{ posinfo.remarks }}
                </el-form-item>
              </el-form>
            </div>
          </el-card>
          <div class="drawmap" id="singlemap1"></div>
        </el-drawer>

      </el-col>
    </el-row>

    <div :style="{ display: mapVisible, }" style="margin-top:10px;"> 
      <div class="card-class" id="containercal2"></div>
      <!--<el-button type="success" class="map_button" icon="el-icon-back" @click="go_backCalendar">日历显示</el-button>-->
    </div>
    </el-dialog>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'rosteringnowduty',
  props: ["funcs"],
  data () {
    return {
      queryObj: {
        pageNum: 1,
        pageSize: 20,
        nowTime: dateutils.dateFormat("YYYY-mm-dd HH:MM:SS", new Date())
      },//查询条件
      pageData: {},
      rosteringPlanInfo: {},//区域信息
      orgTree: [],
      editVisible: false,
      loading: false,
      saving: false,
      mainVisible: "",
      calVisible: "",
      mapVisible: "none",
      selectusername: '',
      queryuser: [],
      personlist: [],
      currentdata: new Date(),
      singleposVisible: false,
      posinfo: [],
      radio: "2",
      visible: false,
      i: '',
      mapData: {}
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadlistRosteringPlanList()
    },
    listRosteringPlanList (orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
          this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadlistRosteringPlanList();
    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },
    //从后台查询区域列表
    loadlistRosteringPlanList () {
      this.loading = true
      this.$ajax.get('/buss/rostering/listRosteringPlanList', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加区域
    edit_init (row) {
      this.editVisible = true
      this.rosteringPlanInfo = JSON.parse(JSON.stringify(row))
    },
     //显示日历信息
   /*displayCalendar (row) {
      console.log(row)
      this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
      this.visible=true
      this.selectusername = row.accountName
      const date = this.$moment(row.startTime); // 使用Moment.js解析字符串时间
      let formattedDate = date.format('YYYYMM');
      this.queryuser = { accountId: row.accountId, dutyTimeMonth: formattedDate }
      this.getpointClockbyperson()
    },*/
 //显示日历信息
    displayCalendar (row) {
      this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
      this.visible=true
      this.selectusername = row.accountName
      this.currentdata = new Date(row.startTime.replace(/-/g, "/"));
      console.log(this.currentdata)
      this.queryuser = { accountId: row.accountId, dutyTimeMonth: this.currentdata }
      this.getpointClockbyperson()
    },
      /*getpointClockbyperson () {
      this.loading = true
      this.$ajax.get('/buss/pointClock/getpointClockbyperson', this.queryuser).then(msg => {
        this.personlist = msg
        console.log("daka" + this.personlist)
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },*/
    getpointClockbyperson () {
      this.loading = true
      this.$ajax.get('/buss/rostering/listRosteringPlanDetailByMonth', this.queryuser).then(msg => {
        console.log(msg)
        this.personlist = msg.calendarData
        this.mapData.mapPointData=msg.mapPointData
        this.mapData.mapFauData=msg.mapFauData
        this.mapData.mapInsData=msg.mapInsData
        this.mapData.mapMaintainData=msg.mapMaintainData
        this.mapData.mapTaskData=msg.mapTaskData
        console.log("daka" + this.personlist)
        console.log("daka" + this.mapData)
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
       //显示地图
    go_map () {


      if (this.personlist != null && this.personlist.length > 0) {
        this.mainVisible = "none"
        this.calVisible = "none"
        this.mapVisible = ""
        this.loadMonthTrackMap()
      }
      else {
        this.$notify({
          title: '警告',
          message: '地图上没有可以显示的打卡记录信息',
          type: 'warning'
        });
      }

    },

    //返回打点首页
    go_backmain () {
      this.mainVisible = ""
      this.calVisible = "none"
      this.mapVisible = "none"
    },

    //返回日历显示
    go_backCalendar () {
      this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
    },

    loadMonthTrackMap () {
      AMapLoader.load({
        key: '204899ccad5874a75849e637df77e6ff',
        version: '2.0',
      }).then((AMap) => {
         var infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -30),
        });
        var map = new AMap.Map("containercal2", {  //设置地图容器id
          viewMode: "3D",    //是否为3D地图模式
          zoom: 7,           //初始化地图级别
          //center: [this.mapData.mapPointData[0].longitude, this.mapData.mapPointData[0].latitude], //初始化地图中心点位置
        });
        
        this.mapData.mapPointData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"</p><p class='input-item'>打卡时间 :"+item.createTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        this.mapData.mapFauData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;故障编号：<a>"+item.code+"</a></p><p class='input-item'>打卡时间 :"+item.solveTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        this.mapData.mapInsData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;巡检设备名称：<a>"+item.assetName+"</p><p class='input-item'>打卡时间 :"+item.finishTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        this.mapData.mapMaintainData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保养设备名称：<a>"+item.assetName+"</p><p class='input-item'>打卡时间 :"+item.doneTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        this.mapData.mapTaskData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;任务名称：<a>"+item.name+"</p><p class='input-item'>打卡时间 :"+item.doneTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        function markerClick(e) {
            infoWindow.setContent(e.target.content);
            infoWindow.open(map, e.target.getPosition());
        }

      }).catch(e => {
        this.$message.error(e)
      })
    },

    openSingleposform (item) {
      
      this.posinfo = item
      this.singleposVisible = true
      this.loadtimeMap(item)
    },

    loadtimeMap (item) {
      AMapLoader.load({
        key: '204899ccad5874a75849e637df77e6ff',
        version: '2.0',
      }).then((AMap) => {
        var map = new AMap.Map("singlemap1", {
          viewMode: "3D",
          zoom: 13,
          center: [item.longitude, item.latitude],
        });
        var marker = new AMap.Marker({
          position: new AMap.LngLat(item.longitude, item.latitude),
          title: item.createTime
        });
        map.add(marker);
        marker.setLabel({
          direction: 'right',
          offset: new AMap.Pixel(-58, -30),
          content: item.createTime,
        })
      }).catch(e => {
        this.$message.error(e)
      })
    },
    to_change(){
      console.log(this.mapData)
      if(this.radio === "1"){
if (this.mapData != null && this.mapData.mapPointData.length>0 || this.mapData.mapFauData.length>0|| this.mapData.mapInsData.length>0||this.mapData.mapMaintainData.length>0|| this.mapData.mapTaskData.length>0) {
        this.mainVisible = "none"
        this.calVisible = "none"
        this.mapVisible = ""
        this.loadMonthTrackMap()
      }
      else {
        this.$notify({
          title: '警告',
          message: '地图上没有可以显示的打卡记录信息',
          type: 'warning'
        });
        this.radio='2'
      }
      }else{
this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
      }
    },
     add_detail_tab(row) {
        console.log(row)
        let param = {
          id: 148,
          label: "值班中心",
          icon: "el-icon-yulanchakan",
          url: "/rostering/rosteringnowdutydetails",
        };
        if (row != null) {
          param.paramId = row;
          
        }
        this.visible=false
        
        this.$emit("add-tab", param);
        
    },

    faucli(){
      alert(1)
    }
  },
   watch: {
     currentdata: function () {
     
      if (this.currentdata.getMonth() != this.queryuser.dutyTimeMonth.getMonth()) {
        this.queryuser.dutyTimeMonth = this.currentdata
        this.getpointClockbyperson()
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.map_button {
  position: absolute;
  top: calc(50vh + 12px);
  right: 10px;
  padding: 0px;
  height: 40px;
  opacity: 0.8;

}

.back_button {
  position: absolute;
  top: calc(50vh + 72px);
  right: 10px;
  padding: 0px;
  height: 40px;
  opacity: 0.8;
}

.card-class {
  height: calc(100vh - 115px);
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.drawtitle {
  height: calc(100vh - 600px);
}

.drawmap {
 height: calc(100vh - 340px);
}
</style>
